import { FeeSubProductDTO } from "@models/platform-analysis/entities/steps/fee";
import { HiddenSubProductDTO } from "@models/reviews/entities/steps/summary";
import { find, split } from "lodash";

export const generateHiddenSubProducts = (
  hiddenIds: string[],
  subProducts: FeeSubProductDTO[],
): HiddenSubProductDTO[] => {
  const hiddenSubProducts: HiddenSubProductDTO[] = [];
  hiddenIds.forEach((id) => {
    const subProduct = find(subProducts, { id });
    if (subProduct) {
      let subProductId = subProduct.id;
      if (subProduct.isRateCard) {
        subProductId = split(subProduct.id, "|")[0];
      }

      hiddenSubProducts.push({
        id: subProductId,
        isRateCard: subProduct.isRateCard ?? true,
        rateCardVersion: subProduct.isRateCard
          ? subProduct.rateCardVersion ?? 0
          : 0,
      });
    }
  });

  return hiddenSubProducts;
};
